import { SupportedMessageFormats } from "../../../Contracts";
import { RequestFormatter, getRequesterIds } from "../../../Common";
import { STR_ERRORS } from "../../Strings";
import { OBQuerySubscribersStore } from "../OBQuerySubscribersStore";
export function OBQRequestFormatter(query) {
    const id = OBQuerySubscribersStore.getQueryID(query);
    const requesterId = getRequesterIds(OBQuerySubscribersStore, query);
    let message = "";
    if (query.name === "Unsubscribe") {
        message = RequestFormatter({
            type: SupportedMessageFormats["jsonrpc2.0"],
            channel: query.name,
            data: {},
            meta: {},
            id: query.params.id
        });
    }
    else {
        if (typeof id === "undefined") {
            throw new Error(STR_ERRORS.OBQRequestFormatRequiresActiveQuery);
        }
        message = RequestFormatter({
            type: SupportedMessageFormats["jsonrpc2.0"],
            channel: query.name,
            data: query.params,
            meta: {
                requesterId
            },
            id
        });
    }
    return message;
}
//# sourceMappingURL=OBQRequestFormatter.js.map